// extracted by mini-css-extract-plugin
export var filterIncDec = "_c6-0";
export var leftBorder = "_c6-1";
export var rightBorder = "_c6-2";
export var stringInput = "_c6-3";